<template lang="html">
  <div class="item-cells price" v-if="product.Id">
    <PriceStep :product="product" :order="order" v-if="isStepOrder"></PriceStep>
    <PriceCommon :product="product" :order="order" v-else></PriceCommon>
  </div>
</template>

<script>
import PriceCommon from './price/price-common'
import PriceStep from './price/price-step'

import { mapState } from 'vuex'
import mixProm from '@/mixin/mixProm'
import { ORDER_STATE_ENUM } from '@/config'

export default {
  mixins: [mixProm],
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    orderStatus: {
      type: Number,
      default: -1
    },
    stateDesc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPendingPayment: this.order.orderState == ORDER_STATE_ENUM.PENDING_PAY
    }
  },
  methods: {},
  computed: {
    ...mapState(['selectedCoupon'])
  },
  components: {
    PriceCommon,
    PriceStep
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.price {
  padding: 0.16rem 0 0.14rem;
  margin: rem(20px) rem(24px);
  background: #ffffff;
  border-radius: rem(16px);
  font-size: rem(26px);
  color: #262626;
  line-height: rem(32px);

  .pay-info {
    .item-cell-hd {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
    }
    .item-cell-bd {
      font-size: rem(26px);
      color: #262626;
      // line-height: rem(32px);
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.pay-num {
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
      }
    }

    .item-cell {
      &:first-child {
        &::after {
          left: rem(20px);
          right: rem(20px);
        }
      }
      &.discount {
        padding-top: 0;
        // padding-bottom: 0;
      }

      &.act-pay {
        padding-top: 0;
        padding-bottom: 0.22rem;
        // i {
        //   margin-left: rem(16px);
        // }
      }
    }

    .totalPrice {
      font-weight: 500;
      color: #121212;
    }
    .actPayYen {
      font-weight: 500;
      color: #ff397e;
    }
    .actPayMoney {
      font-weight: 500;
      color: #ff397e;
      font-size: rem(36px);
    }
  }
}
</style>
